var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConstructorBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-constructor"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "constructor",
    clipPath: "url(#clip-constructor)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11159",
    "data-name": "Group 11159",
    transform: "translate(-6889 2882)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 24,
    height: 24,
    transform: "translate(6889 -2882)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11154",
    "data-name": "Group 11154",
    transform: "translate(6892.875 -2878.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2708",
    "data-name": "Group 2708",
    transform: "translate(5.979 5.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_30",
    "data-name": "\\u30D1\\u30B9 30",
    d: "M996.726,214.437a1.954,1.954,0,1,1-1.953,1.954A1.956,1.956,0,0,1,996.726,214.437Zm0,2.9a.943.943,0,1,0-.943-.943A.944.944,0,0,0,996.726,217.334Z",
    transform: "translate(-991.59 -211.254)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_31",
    "data-name": "\\u30D1\\u30B9 31",
    d: "M994.247,218.457h-1.184a.505.505,0,0,1-.49-.382l-.291-1.161q-.1-.038-.2-.081l-1.026.615a.505.505,0,0,1-.617-.076l-.837-.837a.505.505,0,0,1-.076-.617l.615-1.026q-.043-.1-.081-.2L988.9,214.4a.505.505,0,0,1-.382-.49v-1.184a.505.505,0,0,1,.382-.49l1.161-.291q.038-.1.081-.2l-.615-1.026a.505.505,0,0,1,.076-.617l.837-.837a.505.505,0,0,1,.617-.076l1.026.614q.1-.043.2-.081l.291-1.16a.505.505,0,0,1,.49-.382h1.184a.505.505,0,0,1,.49.382l.291,1.161q.1.038.2.081l1.026-.614a.505.505,0,0,1,.617.076l.837.837a.505.505,0,0,1,.076.617l-.614,1.026q.043.1.081.2l1.161.291a.505.505,0,0,1,.382.49v1.184a.505.505,0,0,1-.382.49l-1.161.291q-.038.1-.081.2l.614,1.026a.505.505,0,0,1-.076.617l-.837.837a.505.505,0,0,1-.617.076l-1.026-.615q-.1.043-.2.081l-.291,1.161A.505.505,0,0,1,994.247,218.457Zm-.789-1.01h.4l.263-1.046a.505.505,0,0,1,.346-.361,2.808,2.808,0,0,0,.546-.225.505.505,0,0,1,.5.01l.924.553.279-.28-.553-.923a.505.505,0,0,1-.011-.5,2.866,2.866,0,0,0,.225-.548.505.505,0,0,1,.361-.346l1.045-.262v-.4l-1.046-.263a.505.505,0,0,1-.361-.346,2.883,2.883,0,0,0-.225-.548.505.505,0,0,1,.011-.5l.553-.923-.279-.279-.924.553a.505.505,0,0,1-.5.011,2.826,2.826,0,0,0-.546-.225.505.505,0,0,1-.347-.361l-.262-1.046h-.4l-.262,1.046a.505.505,0,0,1-.347.362,2.832,2.832,0,0,0-.547.225.505.505,0,0,1-.5-.011l-.923-.553-.28.279.553.923a.505.505,0,0,1,.01.5,2.822,2.822,0,0,0-.225.547.505.505,0,0,1-.362.347l-1.046.263v.4l1.046.262a.505.505,0,0,1,.362.347,2.806,2.806,0,0,0,.224.546.505.505,0,0,1-.01.5l-.553.923.28.28.923-.553a.505.505,0,0,1,.5-.01,2.806,2.806,0,0,0,.546.224.505.505,0,0,1,.347.362Z",
    transform: "translate(-988.519 -208.184)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 2.085,
    height: 2.385,
    rx: 1,
    transform: "translate(2.892 3.112)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 2.085,
    height: 2.385,
    rx: 1,
    transform: "translate(6.595 3.112)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 2.085,
    height: 2.385,
    rx: 1,
    transform: "translate(2.892 6.918)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11172",
    "data-name": "\\u30D1\\u30B9 11172",
    d: "M18.762,48.35H20.58a.742.742,0,0,1,.742.742v3.04a.505.505,0,0,1-.505.505H18.525a.505.505,0,0,1-.505-.505v-3.04A.742.742,0,0,1,18.762,48.35Zm1.549,1.01H19.03v2.266h1.28Z",
    transform: "translate(-13.884 -37.111)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11188",
    "data-name": "\\u30D1\\u30B9 11188",
    d: "M6951.82-2829.148h-1.011V-2843.8a.506.506,0,0,1,.505-.505h10.562v1.01H6951.82Z",
    transform: "translate(-6950.81 2844.305)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_321",
    "data-name": "\\u7DDA 321",
    d: "M8.852.01H-.495A.505.505,0,0,1-1-.495.505.505,0,0,1-.495-1H8.852a.505.505,0,0,1,.505.505A.505.505,0,0,1,8.852.01Z",
    transform: "translate(1 15.524)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_322",
    "data-name": "\\u7DDA 322",
    d: "M-.495,5.568A.505.505,0,0,1-1,5.063V-.495A.505.505,0,0,1-.495-1,.505.505,0,0,1,.01-.495V5.063A.505.505,0,0,1-.495,5.568Z",
    transform: "translate(11.61 1)",
    fill: "#377ef3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConstructorBlue);
export default __webpack_public_path__ + "static/media/icon_constructor_blue.56d9c6b632b059b90eaae4ddbcaf10ee.svg";
export { ForwardRef as ReactComponent };